import { useEffect, useState } from 'react'
import { t } from '../utils'
import { useAuth } from '../utils/auth'
import styles from './_freeTrialBanner.module.scss'
import { useRouter } from 'next/router'

const LOGIN_COOKIE = '_worship_online_used_login='

const hasLoginCookie = () =>
  typeof document !== 'undefined' &&
  document.cookie.split('; ').some((row) => row.startsWith(LOGIN_COOKIE))

const shouldShowBanner = (pathname: string) => {
  if (pathname.startsWith('/signup')) return false
  return !hasLoginCookie()
}

const FreeTrialBanner: React.FC = () => {
  const router = useRouter()
  const { isAuthenticated, isLoading } = useAuth()

  // SSR/first paint false — fixed overlay only, never inserts/removes flow space.
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    if (isLoading) return

    if (isAuthenticated || hasLoginCookie()) {
      setIsShown(false)
      return
    }

    setIsShown(shouldShowBanner(router.asPath))
  }, [isAuthenticated, isLoading, router.asPath])

  if (!isShown) return null

  return (
    <div className={styles.banner}>
      <a href="https://worshiponline.com">{t('Start my free trial')}</a>
    </div>
  )
}

export default FreeTrialBanner
